import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core';
import { CreateSessionBody, CreateSessionResponse, GetSessionResponse } from './dto';

@Injectable({ providedIn: 'root' })
export class SessionsService extends ApiService {
  create(body: CreateSessionBody): Observable<CreateSessionResponse> {
    return this.httpClient.post<CreateSessionResponse>(`${this.env.apiUrl}/sessions`, body);
  }

  getOne(sessionId: string): Observable<GetSessionResponse> {
    return this.httpClient.get<GetSessionResponse>(`${this.env.apiUrl}/sessions/${sessionId}`);
  }
}
